import { ShareModal } from './ShareModal';

export { ShareModal } from './ShareModal';
export type { ShareModalProps } from './ShareModal.types';

export default ShareModal;
